<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1PZfVr/tc-custom/9781453252284.jpg?1704523423413" alt="This image is the cover for the book Deserter, The Homer Kelly Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Deserter, The Homer Kelly Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>Gettysburg deserter or Civil War hero? Scholar/sleuth Homer Kelly and his wife, Mary, solve the mystery of her great-great-grandfather in this “clever” novel (<i>Booklist</i>).</b><br/>  Homer and Mary Kelly have wandered through Harvard University’s Memorial Hall dozens of times, but never have they lingered over the long list of alumni who died for the Union during the Civil War. One afternoon, the setting sun casts its light on the name of Seth Morgan, Mary’s disgraced great-great-grandfather. She knows little of her ancestor’s life, for family lore holds that he was a deserter, and a blight on the Morgan name. But as she and her husband dig into the dead man’s story, they find something astonishing. The mystery deepens as the story shifts from past to present. Even in 1863 it was difficult to know just what happened on the blood-soaked fields of Gettysburg, but no matter what it takes, Homer and Mary will find truth, and restore the honor of a man who died fighting for his country.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jane Langton
      </h2>
      
      <p class="authorDescription body article">Winner of the Bouchercon Lifetime Achievement Award, Jane Langton (1922&ndash;2018) was an acclaimed author of mystery novels and children&rsquo;s literature. Born in Boston, Massachusetts, Langton took degrees in astronomy and art history before she began writing novels, and has set much of her fiction in the tight-knit world of New England academia.<BR /> &#160;<BR /> She published her first novel, <I>The Majesty of Grace</I>, in 1961, and a year later began one of the young adult series that would make her famous: the Hall Family Chronicles. In <I>The Diamond in the Window</I> (1962) she introduced Edward and Eleanor, two New England children whose home holds magical secrets. Two years later, in <I>The Transcendental Murder</I>, Langton created Homer Kelly, a Harvard University professor who solves murders in his spare time. These two series have produced over two dozen books, most recently <I>The Dragon Tree</I> (2008), the eighth Hall Family novel.<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c4c3b6a4